<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>品牌着陆页信息添加</span>
      </div>
      <el-form
        ref="userForm"
        :model="brandInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label="品牌名称：" prop="brandName">
            <el-input v-model="brandInfo.brandName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过20个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="品牌编码：" prop="brandCode">
            <el-input v-model="brandInfo.brandCode"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过20个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="跳转地址：" prop="brandUrl">
            <el-input v-model="brandInfo.brandUrl"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过400个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      roleOptions: [],
      brandInfo: {
        brandId: "",
        brandName: "",
        brandCode: "",
        brandUrl: ""
      },
      rules: {
        brandName: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ],
        brandCode: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ],
        brandUrl: [
          {
            max: 400,
            message: "最多输入400个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    add() {
      let _this = this;
      _this.$refs.userForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/brand/saveBrandInfo",
            params: {
              brandName: _this.brandInfo.brandName,
              brandCode: _this.brandInfo.brandCode,
              brandUrl: _this.brandInfo.brandUrl
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "品牌信息添加成功",
                  type: "success"
                });
                this.$router.push({
                  name: "brandIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善品牌信息!",
            type: "warning"
          });
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
